import { serviceRoutes, post } from './index';

export const crearVentaAliado = async (body) => await post(serviceRoutes.crearVentaAliado, body);
